import { Button, Field } from 'components/commons';
import React, { useCallback } from 'react';
import styles from './trial-balance-filter.module.scss';

import DateRange from 'components/commons/date-range/date-range';

const TrialBalanceFilter = ({
  filterState,
  onTypeChange,
  onSearchChange,
  onSearch,
  onDateRangeChange,
  onDownloadFile
  // onRouteChange,
  // onUserChange,
  // fetchingReport
}) => {
  const onDateRangeChangeCb = useCallback(
    (name, { value, dirty }) => {
      if (onDateRangeChange) return onDateRangeChange(value, dirty);
    },
    [onDateRangeChange]
  );

  // const onSearchChangeCb = useCallback(
  //   (name, { value }) => {
  //     if (onSearchChange) {
  //       return onSearchChange('searchKey', { value });
  //     }
  //   },
  //   [onSearchChange]
  // );

  // const onSearchCb = useCallback(
  //   (searchKey) => {
  //     if (onSearch) {
  //       return onSearch(searchKey);
  //     }
  //   },
  //   [onSearch]
  // );

  return (
    <div className={styles.filter}>
      <div className={styles.filterContent}>
        <Field className={styles.date} label={'Date'}>
          <DateRange
            value={{
              startDate: filterState.startDate,
              endDate: filterState.endDate
            }}
            onChange={onDateRangeChangeCb}
          />
        </Field>
        {/* <Field className={styles.search} label="Search">
          <SearchField
            placeholder={'OR Number, Reference Number'}
            value={filterState.searchKey}
            onChange={onSearchChangeCb}
            onEnter={onSearchCb}
            restrict={false}
          />
        </Field> */}
      </div>
      <Field className={styles.downloadButton}>
        <Button exportButton onClick={onDownloadFile} eventName={Event.DownloadRedemptionReport}>
          Export
        </Button>
      </Field>
    </div>
  );
};

export default TrialBalanceFilter;
